import { render, staticRenderFns } from "./robotreply.vue?vue&type=template&id=2814a6bf&scoped=true&"
import script from "./robotreply.vue?vue&type=script&lang=js&"
export * from "./robotreply.vue?vue&type=script&lang=js&"
import style0 from "./robotreply.vue?vue&type=style&index=0&id=2814a6bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2814a6bf",
  null
  
)

export default component.exports